import { render, staticRenderFns } from "./vcPerson.vue?vue&type=template&id=80153aa0&"
import script from "./vcPerson.vue?vue&type=script&lang=js&"
export * from "./vcPerson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports